var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_vm._v(" サインイン、サインアップすることであなたは "),_c('a',{attrs:{"href":"https://www.seaplus.style/termsofservice"}},[_vm._v("利用規約")]),_vm._v(" と "),_c('a',{attrs:{"href":"https://www.seaplus.style/privacypolicy"}},[_vm._v("プライバシーポリシー")]),_vm._v(" に同意したことになります。 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }